<div id="content" class="allcp-form" ng-controller="TeamController" ng-init="show()">
	<div ng-include="'modules/company/menus/user_menu.html'"></div>
	<div class="row mt20">
		<div class="panel">
			<div class="panel-heading">
				<span class="panel-title"> Ekip Düzenle</span>
				<hr>
			</div>
			<div class="panel-body">

				<form ng-submit="updateTeam()" class="form-horizontal">
					<div class="section row mbn allcp-form theme-primary">
						<div class="col-md-8">

							<div class="form-group">
								<label class="col-md-3 control-label">Ekip Adı : </label>
								<div class="col-md-9">
									<label for="name21" class="field prepend-icon">
										<input type="text" ng-model="team.name" class="event-name gui-input br-light light" required>
										<label for="name21" class="field-icon">
											<i class="fa fa-users"></i>
										</label>
									</label>
								</div>
							</div>

							<div class="form-group">
								<label class="col-md-3 control-label">Ekip Açıklaması : </label>
								<div class="col-md-9">
									<label for="name21" class="field prepend-icon">
										<textarea rows="5" cols="10" class="form-control" ng-model="team.description"></textarea>
										<label for="name21" class="field-icon">
											<i class="fa fa-paperclip"></i>
										</label>
									</label>
								</div>
							</div>

							<div class="form-group">
								<label class="col-md-3 control-label">
									Konum Doğruluk ve Hız Derecesi : 
									<a href="#" class="hint--medium hint--top-left" aria-label="Yüksek seçim şarj durumlarını etkileyebilir. Buradaki değişikliklerin uygulamalara yansıması biraz zaman alabilir."><i class="fa fa-question-circle"></i> </a>
								</label>
								<div class="col-md-9">
									<label for="name21" class="field">
										<select ng-model="team.location_density" ng-init="team.location_density = 'high'" class="form-control">
											<option value="none">Canlı Takip Yok</option>
											<option value="low">Düşük</option>
											<option value="middle">Orta</option>
											<option value="high">Yüksek</option>
										</select>
									</label>
								</div>
							</div>

							<div class="form-group">
								<label class="col-md-3 control-label">Çalışan : </label>
								<div class="col-md-9">
									<label for="name21" class="field">
										<ui-select ng-model="team.workers" title="Çalışanlar" multiple>
											<ui-select-match placeholder="Çalışan Seçiniz...">{{ $item.user.full_name }}</ui-select-match>
											<ui-select-choices repeat="item as item in (workers | filter: $select.search) track by $index">
												<div class="row mr10 ml10">
													<span ng-bind="item.user.full_name"></span>
												</div>
											</ui-select-choices>
										</ui-select>
									</label>
								</div>
							</div>
							
							<div class="form-group">
								<div class="col-md-12">
									<button type="submit" class="btn btn-primary pull-right"><span class="fa fa-save"></span> Güncelle</a>
								</div>
							</div>
						</div>
					</div>
				</form>
			</div>

		</div>
	</div>

</div>